if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        // Detect button type from submitter
        const buttonType = evt.submitter?.dataset?.buttonType || 'add-to-cart';
        const isBuyNow = buttonType === 'buy-now';

        // Get the actual button that was clicked
        const clickedButton = evt.submitter || this.submitButton;
        clickedButton.setAttribute('aria-disabled', true);
        clickedButton.classList.add('loading');
        const spinner = clickedButton.querySelector('.loading__spinner');
        if (spinner) spinner.classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        
        // Only add sections for regular add-to-cart (not buy now)
        if (this.cart && !isBuyNow) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = clickedButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              clickedButton.setAttribute('aria-disabled', true);
              const buttonText = clickedButton.querySelector('span:not(.sold-out-message)');
              if (buttonText) buttonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (isBuyNow) {
              // Buy now: redirect to checkout immediately
              window.location = window.routes.cart_url.replace('/cart', '/checkout');
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    if (this.cart) this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else if (this.cart) {
              this.cart.renderContents(response);
            }
            
            // Force update cart icon/bubble count
            this.updateCartCount(response);
            
            // Show success notification for add-to-cart
            if (!isBuyNow) {
              this.showAddedToCartNotification(clickedButton);
              // Reload page after brief delay to update cart
              setTimeout(() => {
                window.location.reload();
              }, 500);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            // Don't remove loading state for buy now since we're redirecting
            if (!isBuyNow) {
              clickedButton.classList.remove('loading');
              if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
              if (!this.error) clickedButton.removeAttribute('aria-disabled');
              if (spinner) spinner.classList.add('hidden');
            }
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      updateCartCount(response) {
        // Update cart count in header icon/bubble
        const cartCountBubbles = document.querySelectorAll('.cart-count-bubble span, #cart-icon-bubble span');
        if (response.item_count !== undefined) {
          cartCountBubbles.forEach(bubble => {
            bubble.textContent = response.item_count;
          });
        }
        
        // Show/hide bubble based on count
        const cartBubbles = document.querySelectorAll('.cart-count-bubble, #cart-icon-bubble');
        cartBubbles.forEach(bubble => {
          if (response.item_count > 0) {
            bubble.classList.remove('hidden');
          }
        });
      }

      showAddedToCartNotification(button) {
        // Create notification element
        const notification = document.createElement('div');
        notification.className = 'product-form__success-notification';
        notification.textContent = '✓ Added to cart';
        notification.style.cssText = `
          position: fixed;
          top: 20px;
          right: 20px;
          background-color: #4CAF50;
          color: white;
          padding: 16px 24px;
          border-radius: 4px;
          box-shadow: 0 4px 6px rgba(0,0,0,0.1);
          z-index: 10000;
          font-size: 14px;
          font-weight: 500;
          animation: slideInRight 0.3s ease;
        `;
        
        document.body.appendChild(notification);
        
        // Remove after 3 seconds
        setTimeout(() => {
          notification.style.animation = 'slideOutRight 0.3s ease';
          setTimeout(() => {
            document.body.removeChild(notification);
          }, 300);
        }, 3000);
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
